<template>
  <div class="flex w-72 flex-col gap-4 px-4 py-3">
    <UiComboboxMultiVee
      v-if="tierOptions.length > 0"
      name="tierFilterIDs"
      :label="$t('W: Næste levering')"
      :modelValue="tierIDs"
      :options="tierOptions"
      :placeholder="$t('W: Alle')"
      :searchPlaceholder="$t('term.search')"
      :emptyText="$t('W: Ingen resultater')"
      @update:model-value="onTierIDsChange" />

    <UiComboboxMultiVee
      name="insuranceCustomerAccountFilterIDs"
      :label="$t('W: Forsikringskunde')"
      :modelValue="insuranceCustomerAccountIDs"
      :options="insuranceCustomerAccountOptions"
      :placeholder="$t('W: Alle')"
      :searchPlaceholder="$t('term.search')"
      :emptyText="$t('W: Ingen resultater')"
      @update:model-value="onInsuranceCustomerAccountIDsChange" />

    <Toggle
      :modelValue="hideInternal"
      :label="$t('area.order.filter.hide-internal')"
      @update:model-value="onHideInternalChange" />

    <Toggle
      :modelValue="missingInsuranceNumberOnly"
      :label="$t('W: Mangler skadesnummer')"
      @update:model-value="onMissingInsuranceNumberOnlyChange" />

    <div class="flex items-center justify-between border-t border-border-subtle pt-3">
      <button
        type="button"
        class="cursor-pointer text-sm text-action disabled:cursor-not-allowed disabled:opacity-40"
        :disabled="!hasActiveFilters"
        @click="onClearClick">
        {{ $t('W: Ryd filtre') }}
      </button>
      <transition
        enterActiveClass="transition-opacity duration-150"
        enterFromClass="opacity-0"
        leaveActiveClass="transition-opacity duration-500"
        leaveToClass="opacity-0">
        <span v-if="showSavedFlash" class="text-xs text-text-muted">
          {{ $t('W: Gemt') }}
        </span>
      </transition>
    </div>
  </div>
</template>

<script lang="ts">
import { useOrdersFilterStore } from '@/stores/ordersFilterStore'
import { mapActions, mapState } from 'pinia'

export default {
  name: 'OrdersFilterMenu',

  emits: ['close'],

  props: {
    tierOptions: {
      type: Array as () => { value: string; text: string }[],
      required: true,
    },
    insuranceCustomerAccountOptions: {
      type: Array as () => { value: string; text: string }[],
      required: true,
    },
  },

  data() {
    return {
      showSavedFlash: false,
      savedFlashTimeout: null as ReturnType<typeof setTimeout> | null,
    }
  },

  computed: {
    ...mapState(useOrdersFilterStore, [
      'tierIDs',
      'insuranceCustomerAccountIDs',
      'hideInternal',
      'missingInsuranceNumberOnly',
      'hasActiveFilters',
    ]),
  },

  methods: {
    ...mapActions(useOrdersFilterStore, [
      'setTierIDs',
      'setInsuranceCustomerAccountIDs',
      'setHideInternal',
      'setMissingInsuranceNumberOnly',
      'clearFilters',
    ]),

    onTierIDsChange(ids: string[]) {
      this.setTierIDs(ids)
      this.flashSaved()
    },

    onInsuranceCustomerAccountIDsChange(ids: string[]) {
      this.setInsuranceCustomerAccountIDs(ids)
      this.flashSaved()
    },

    onHideInternalChange(value: boolean) {
      this.setHideInternal(value)
      this.flashSaved()
    },

    onMissingInsuranceNumberOnlyChange(value: boolean) {
      this.setMissingInsuranceNumberOnly(value)
      this.flashSaved()
    },

    onClearClick() {
      this.clearFilters()
      this.flashSaved()
    },

    flashSaved() {
      this.showSavedFlash = false
      this.$nextTick(() => {
        this.showSavedFlash = true
        if (this.savedFlashTimeout) clearTimeout(this.savedFlashTimeout)
        this.savedFlashTimeout = setTimeout(() => {
          this.showSavedFlash = false
        }, 1500)
      })
    },
  },

  beforeUnmount() {
    if (this.savedFlashTimeout) clearTimeout(this.savedFlashTimeout)
  },
}
</script>
